/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import Immutable from "seamless-immutable";
import {
  POST_NEW_SEARCH_FAILURE,
  POST_NEW_SEARCH_REQUEST,
  POST_NEW_SEARCH_SUCCESS
} from "../actions/search";

const INITIAL_STATE = Immutable({
  results: null
});

function search(state = INITIAL_STATE, action) {
  switch (action.type) {
    case POST_NEW_SEARCH_REQUEST:
      return state.setIn(["loading"], true);
    case POST_NEW_SEARCH_SUCCESS:
      return state
        .setIn(["loading"], false)
        .setIn(["results", action.keyword], action.data);
    case POST_NEW_SEARCH_FAILURE:
      return state.setIn(["loading"], false);
    default:
      return state;
  }
}
export default search;



// WEBPACK FOOTER //
// ./src/reducers/search.js